export default __webpack_public_path__ + "static/Advanced_Bullet-ef2b6ff011f992d15e4b4b8e98b76719.png";